module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjYuNzUiIGN5PSI2LjMyNjE3IiByPSI2IiBmaWxsPSIjQThBOEE4Ii8+DQo8cGF0aCBkPSJNNS41NjQyOCA0LjE0NDUzTDcuOTM0NTcgNi40MTUyOEw1LjczMDE0IDguNTA4MTciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/next.svg
// module id = KkNP
// module chunks = 0